import { WidgetSizeEnum } from 'types/schema';
import { transportationIcons } from 'utils/assets';
import { ExcludedTransportModeType } from 'api/get-transit';
import { formatViewport } from 'utils/get-pixels-to-viewport';
import { colors } from 'utils/generate-theme';

export const getStationsCountBasedOnWidgetSize = (widgetSize: WidgetSizeEnum) => {
    switch (widgetSize) {
    case WidgetSizeEnum.FullColumn:
        return 4;
    case WidgetSizeEnum.HalfColumn:
        return 2;
    case WidgetSizeEnum.HorizontalColumn:
        return 2;
    case WidgetSizeEnum.SquareColumn:
        return 4;
    default:
        return 1;
    }
};

export const getTransportationIcon = (type: ExcludedTransportModeType, color?: string, width?: number, height?: number) => {
    const Component = transportationIcons[type as keyof typeof transportationIcons || 'bus'];
    return Component ? <Component fill={color || colors.black} width={formatViewport(width || 20)} height={formatViewport(height || 20)} /> : null;
};